import { render } from "./IngresoMasivo.vue?vue&type=template&id=408cdf3b&scoped=true"
import script from "./IngresoMasivo.vue?vue&type=script&lang=js"
export * from "./IngresoMasivo.vue?vue&type=script&lang=js"

import "./IngresoMasivo.vue?vue&type=style&index=0&id=408cdf3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408cdf3b"]])

export default __exports__